import React, {Component} from 'react';
import {connect} from 'react-redux';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import {Icon, Message} from 'semantic-ui-react';

import Group from '../components/Group';

import {clearNotifications} from '../actions/notifications';
import {haveDifferentKeys} from '../utils/compare';

import './Notifications.css';

class Notifications extends Component {

    shouldComponentUpdate({notifications}) {
        return haveDifferentKeys(notifications, this.props.notifications);
    }

    render() {
        const {className, notifications} = this.props;
        return <Group className={classNames(className, "Notifications")}>
            {
                notifications.length > 1
                    ? <a onClick={this.props.clearNotifications} className="Notifications-clear" key="clear">
                            <Icon name='close'/>
                            Clear
                        </a>
                    : null
            }
            {notifications.map(n => <Message className="Notification" {...n}/>)}
        </Group>;
    }
}

Notifications.propTypes = {
    clearNotifications: PropTypes.func.isRequired,
    notifications: PropTypes
        .arrayOf(PropTypes.shape({
            content: PropTypes.string.isRequired,
            key: PropTypes
                .oneOfType([PropTypes.string, PropTypes.number])
                .isRequired,
            onDismiss: PropTypes.func
        }))
        .isRequired
};

export default connect(({notifications}) => ({notifications}), {clearNotifications})(Notifications);



// WEBPACK FOOTER //
// ./src/containers/Notifications.js